import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { push, routerActions } from "connected-react-router";
import { bool, string, shape } from "prop-types";
import { Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { selectors as softTokenSelectors } from "reducers/softToken";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import FormattedAmount from "pages/_components/FormattedAmount";

const NewPaymentConfirm = ({ isDesktop, servicePaymentData, addedServicePaymentData }) => {
    const [transactionData, setTransactionData] = useState(null);
    const dispatch = useDispatch();

    const normalizedServicePaymentData = servicePaymentData?.params ?? servicePaymentData ??  {};

    if (servicePaymentData?.params) {

        normalizedServicePaymentData.account = {
            label: servicePaymentData.params.accountLabel,
            type: servicePaymentData.params.accountType,
            currency: servicePaymentData.amount.currency
        }

        normalizedServicePaymentData.amountField = {
            amount: servicePaymentData.amount.quantity
        }

        normalizedServicePaymentData.idTransaction = servicePaymentData?.idTransaction;

        servicePaymentData = normalizedServicePaymentData;
    }

    const onBack = () => {
        dispatch(routerActions.goBack());
        dispatch(afipPaymentLinkActions.resetServicePaymentInfo());
    };

    useEffect(() => {
        if (servicePaymentData) {
            const {
                categoryId,
                entityId,
                conceptId,
                paymentCode,
                categoryName,
                entityName,
                conceptName,
                alias,
                referenceText,
                reference,
                addServicesChecked,
                account,
                debtId,
                conceptAmountValue,
            } = servicePaymentData;

            const params = {
                categoryId,
                entityId,
                conceptId,
                paymentCode,
                categoryName,
                entityName,
                conceptName,
                alias,
                adheredAlias: addedServicePaymentData !== null ? addedServicePaymentData?.alias : null,
                referenceText,
                reference,
                accountId: account?.id,
                accountLabel: account?.label,
                accountType: account?.type,
                currency: account?.currency,
                debtId,
                conceptAmountValue,
                addServicesChecked,
                paymentFromAdheredService: addedServicePaymentData !== null,
            };
            setTransactionData({
                params,
                amount: {
                    currency: servicePaymentData?.account?.currency,
                    quantity: servicePaymentData?.amountField?.amount,
                },
                idTransaction: servicePaymentData.idTransaction,
            });
        }
    }, [servicePaymentData]);

    const hasAlias = () => (servicePaymentData && servicePaymentData?.addServicesChecked && servicePaymentData.alias) || (addedServicePaymentData && addedServicePaymentData?.alias);
    const className = hasAlias() ? "add-service-table-with-alias" : "add-service-table";

    const title = !addedServicePaymentData ? "new.service.payment.link.title" : "pay.added.service.link.title";
    const defaultTitle = !addedServicePaymentData ? "Nuevo Pago de Servicios" : "Pagar Servicio Adherido";

    return (
        <>
            <Notification scopeToShow="NewPaymentConfirmPage" />
            <ResponsiveHeader
                id={title}
                defaultTitle={defaultTitle}
                onClickBack={onBack}
            />
            <MainContainer className="discounts-echeq-review">
                <CustomText
                    text={i18n.get("vep.payment.data.review.title", "Confirmá la transacción")}
                    textType="TEXT"
                    className="discounts-echeq-review__date-control"
                    defa
                />
                <div className="py-3" />
                <Row className="form-background" style={{ padding: "2rem 0px 2rem 5rem" }}>
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.account.label", "Cuenta débito")}
                            titleClass="text-Primary-primary-color"
                            valueText={`${servicePaymentData?.account?.label} ${servicePaymentData?.account?.type
                                } ${i18n.get(`currency.label.${servicePaymentData?.account?.currency}`, "")}`}
                        />
                    </Col>
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("new.service.payment.link.concept.label", "Concepto")}
                            titleClass="text-Primary-primary-color"
                            valueText={servicePaymentData?.conceptName}
                        />
                    </Col>
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.category.selector.label", "Rubro")}
                            titleClass="text-Primary-primary-color"
                            valueText={servicePaymentData?.categoryName}
                        />
                    </Col>
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.entity.selector.label", "Empresa")}
                            titleClass="text-Primary-primary-color"
                            valueText={servicePaymentData?.entityName}
                        />
                    </Col>
                    {servicePaymentData?.conceptAmountValue && <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.amount.debt", "Importe Adeudado")}
                            titleClass="text-Primary-primary-color"
                            valueText={<FormattedAmount
                                className="data-label"
                                currency="ARS"
                                quantity={servicePaymentData?.conceptAmountValue}
                            />}
                        />
                    </Col>}
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.amount.label", "Monto a abonar")}
                            titleClass="text-Primary-primary-color"
                            valueText={<FormattedAmount
                                className="data-label"
                                currency="ARS"
                                quantity={servicePaymentData?.amountField?.amount}
                            />}
                        />
                    </Col>
                    {servicePaymentData?.referenceText && servicePaymentData?.reference && <Col xs={6} md={3}>
                        <CustomData
                            titleText={servicePaymentData?.referenceText}
                            titleClass="text-Primary-primary-color"
                            valueText={servicePaymentData?.reference}
                        />
                    </Col>}
                    <Col xs={6} md={3}>
                        <CustomData
                            titleText={i18n.get("services.payment.link.paymentCode.label", "Código de pago")}
                            titleClass="text-Primary-primary-color"
                            valueText={servicePaymentData?.paymentCode}
                        />
                    </Col>
                    {hasAlias() && (
                        <Col xs={6} md={3}>
                            <CustomData titleText={i18n.get("adheredServices.link.alias", "Alias")} valueText={servicePaymentData?.alias || addedServicePaymentData?.alias} />
                        </Col>
                    )}
                </Row>

                <Formik
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                >
                    {() => (
                        <>
                            <Row className="form-actions">
                                <GeneralCredentialForm
                                    transactionData={transactionData}
                                    type="otp"
                                    action={afipPaymentLinkActions.generateServicePayment}
                                    idActivity="generate.service.payment.link"
                                    hideIndications
                                />
                            </Row>
                        </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

NewPaymentConfirm.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    servicePaymentData: shape({}).isRequired,
    fetching: bool.isRequired,
    addedServicePaymentData: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    fetching: afipPaymentLinkSelectors.getFetching(state),
    servicePaymentData: afipPaymentLinkSelectors.getServicesPaymentData(state),
    cuitIsAdhered: afipPaymentLinkSelectors.getCuitIsAdhered(state),
    addedServicePaymentData: afipPaymentLinkSelectors.getAddedServicePaymentData(state),
});
export default connect(mapStateToProps)(NewPaymentConfirm);
